<template>
  <v-dialog
    v-model="display"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    width="600px"
    max-height="400px"
    scrollable
    persistent
    class="rounded-0"
  >
    <v-card v-if="booking" class="mx-auto secondary rounded-0" elevation="0">
      <CardHeader
        :title="'Hændelser - Bookingnr. ' + booking.bookingno"
        icon="mdi-close"
        @iconClicked="callback"
      />
      <v-card-text style="height: 500px;">
        <v-data-table
          :headers="headers"
          :items="events"
          hide-default-footer
          class="secondary accent--hover"
          dense
          no-data-text="Ingen hændelser"
        >
          <template v-slot:item.timestamp="{ item }">
            <!-- ignore eslint error regarding v-slot directive!!! -->
            {{ formatDateTime(item.timestamp) }}
          </template>
          <template v-slot:item.eventtype="{ item }">
            <!-- ignore eslint error regarding v-slot directive!!! -->
            {{ translateEventType(item.eventtype) }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="callback">
          LUK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { tools, dictionary } from "@/helpers";
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  name: "BookingEventsDialog",
  components: {
    CardHeader
  },
  props: {
    display: Boolean,
    booking: {
      type: Object,
      required: true
    },
    events: {
      type: Array,
      required: true
    },
    callback: {
      type: Function,
      required: true
    }
  },
  computed: {
    headers() {
      let headers = [];
      headers.push({ text: "Tidspunkt", value: "timestamp", width: "25%" });
      headers.push({
        text: "Hændelse",
        value: "eventtype",
        width: "20%",
        sortable: false
      });
      headers.push({
        text: "Stop",
        value: "remark",
        width: "55%",
        sortable: false
      });
      return headers;
    }
  },
  methods: {
    formatDateTime(dateTime) {
      if (dateTime) {
        const dt = tools.splitDateTime(new Date(dateTime));
        return tools.formatDate(dt.date) + " " + dt.time;
      }
      return "";
    },
    translateEventType(eventtype) {
      switch (eventtype) {
        case "RECEIVED":
          return dictionary.constants.events.received;
        case "ACCEPTED":
          return dictionary.constants.events.accepted;
        case "REJECTED":
          return dictionary.constants.events.rejected;
        case "UNSUCCESFUL":
          return dictionary.constants.events.unsuccesful;
        case "ARRIVAL":
          return dictionary.constants.events.arrival;
        case "DEPARTURE":
          return dictionary.constants.events.departure;
        case "DELAY":
          return dictionary.constants.events.delay;
        case "WAITING":
          return dictionary.constants.events.waiting;
        case "INVOICED":
          return dictionary.constants.events.invoiced;
        default:
          return "";
      }
    }
  }
};
</script>
